import { render } from "./VerticalRulePage.vue?vue&type=template&id=60f42c9c&ts=true"
import script from "./VerticalRulePage.vue?vue&type=script&lang=ts"
export * from "./VerticalRulePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__